<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "systems",
    cardSetLink: "systems",
    item: null,
    fields: [
    {
        col: 'col-12',
        label: 'Лимит времени (токен)',
        key: 'is_lifetime_token',
        type: 'checkbox'
      },
      {
        col: 'col-12 col-md-6',
        label: 'Название',
        key: 'name',
        type: 'field'
      },
      {
        col: 'col-12 col-md-6',
        label: 'Код',
        key: 'code',
        type: 'field'
      },

      {
        col: 'col-12 col-md-6',
        label: 'Логин',
        key: 'api_login',
        type: 'field'
      },
   
      {
        col: 'col-12 col-md-6',
        label: 'Пароль',
        key: 'api_password',
        type: 'field'
      },
      {
        col: 'col-12 col-md-6',
        label: 'ENDPOINT URL',
        key: 'api_endpoint_url',
        type: 'field'
      },
      {
        col: 'col-12 col-md-6',
        label: 'Тип авторизации',
        key: 'api_auth_type',
        type: 'field'
      },
      {
        col: 'col-12 col-md-6',
        label: 'TOKEN',
        key: 'api_token',
        type: 'field'
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
